/// <amd-module name="Artifacts/PackageRecycleBin/redux/Contracts" />

import { IDeletedPackageVersion } from "Artifacts/PackageRecycleBin/types";
import { ComponentState } from "Artifacts/Root/Constants";

export type IPackageRecycleBinState = {
  componentState: ComponentState;
  emptyButtonState: ComponentState;
  pkgVersions?: IDeletedPackageVersion[];
};
